import { apiSlice } from './apiSlice';

export const authApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Login
    login: builder.mutation<
      { accessToken: string; user: any; passwordChanged: Boolean },
      {
        username: string;
        password: string;
      }
    >({
      query: (body) => ({
        url: '/auth/result/login',
        method: 'POST',
        body,
      }),
    }),

    //logout
    logout: builder.mutation<any, void>({
      query: () => ({
        url: '/auth/logout',
        method: 'POST',
      }),
    }),

    // new captcha endpoint
    getCaptcha: builder.query<any, void>({
      query: () => ({
        url: '/captcha',
        method: 'POST',
      }),
    }),
  }),
});

export const {
  useGetCaptchaQuery,
  useLazyGetCaptchaQuery,
  useLoginMutation,
  useLogoutMutation,
} = authApi;
